import { first, mapMaybe, take } from '@execonline-inc/collections';
import { pipe } from '@kofno/piper';
import { Maybe, fromEmpty, just } from 'maybeasy';
import { observer } from 'mobx-react';
import { join, split } from 'ramda';
import { avatarFrom } from '../../../../../../Avatar';
import { GroupResource } from '../../../../../../GroupsStore/Types';
import { findLink } from '../../../../../../LinkyLinky';
import { NotTranslated } from '../../../../../../Translations';
import PersonPhoto from '../../../../../PersonPhoto';

interface Props {
  group: GroupResource;
}

const initials = mapMaybe(pipe(split(''), first));

const groupInitials = (groupName: string): Maybe<string> =>
  just(groupName).and(split(' ')).and(take(2)).and(initials).andThen(fromEmpty).map(join(''));

function GroupInfo({ group }: Props) {
  return (
    <div className="flex py-4 gap-2 items-center">
      <div className="flex" data-test-person={true}>
        <div
          className="relative h-10 w-10 min-w-[100%] rounded-full bg-[#187A90]"
          data-test-person-avatar={true}
        >
          <PersonPhoto
            avatar={avatarFrom(findLink('avatar', group.links), groupInitials(group.payload.name))}
          />
        </div>
      </div>
      <span>
        <NotTranslated text={group.payload.name} />
      </span>
    </div>
  );
}

export default observer(GroupInfo);
